<template>
  <div id="human-resources-view" v-if="$canAndRulesPass(user, 'resources_evaluation.see_matrix')">

    <human-resources-matrix-header style="margin-bottom: 20px"></human-resources-matrix-header>


    <human-resources-matrix-block
      v-show="showMatrix1"
      id="human-resources-matrix-1"
      ref="human-resources-matrix-1"
      style="margin-bottom: 20px"

      name="Матрица эффективности и потенциала"

      :row-evaluation-type="3"
      :row-evaluation-type-comment="null"
      row-point-name="evaluate_potential_id"
      :col-evaluation-type="4"
      :col-evaluation-type-comment="null"
      col-point-name="evaluate_final_efficiency_id"
      :rows-name-configs="{
        1: {evaluationId: 11},
        2: {evaluationId: 10},
        3: {evaluationId: 9},
      }"
      :cols-name-configs="{
        1: {evaluationId: [13, 12]},
        2: {evaluationId: 14},
        3: {evaluationId: 15},
      }"
      :table-cells-config="{
        '1_1': {name: '6. Развивающийся сотрудник', desc:'<b>Описание</b>: Сотрудник, недавно переведенный на данную позицию, или развивающийся сотрудник, который обладает исключительным потенциалом для перевода на более высокую, критическую позицию или способен расширить функционал текущей позиции, но может показывать разный уровень эффективности. <br><b>Рекомендуемое действие по сотруднику</b>: Развитие '},
        '1_2': {name: '8. Перспективный сотрудник', desc: '<b>Описание</b>: Успешный сотрудник, имеющий очень большое стремление, способности и высокий уровень вовлеченности для продвижения на более высокую, критическую позицию. <br><b>Рекомендуемое действие по сотруднику</b>: Развитие / Расширение функционала / Проекты'},
        '1_3': {name: '9. Топ талант', desc: '<b>Описание</b>: Сотрудник стабильно перевыполняет с высоким уровнем качества широкий спектр разнообразных задач. Проявляет большое стремление, способности и высокий уровень вовлеченности для перевода на более высокую, критическую позицию. <br><b>Рекомендуемое действие по сотруднику</b>: Расширение функционала / Проекты'},
        '2_1': {name: '2. Нестабильный сотрудник', desc: '<b>Описание</b>: Сотрудник, недавно переведенный на данную позицию, или развивающийся сотрудник, обладающий стремлением, способностями и вовлеченностью для роста – возможно повышение эффективности при горизонтальном перемещении на том же уровне.<br><b>Рекомендуемое действие по сотруднику</b>: Наблюдение / Поддержка'},
        '2_2': {name: '5. Эффективный сотрудник', desc: '<b>Описание</b>: Успешный стабильный сотрудник, обладающий стремлением, способностями и вовлеченностью для дальнейшего роста на более высокую, критическую позицию или позицию с более широким функционалом.<br><b>Рекомендуемое действие по сотруднику</b>: Развитие'},
        '2_3': {name: '7. Выдающийся сотрудник', desc: '<b>Описание</b>: Лучший сотрудник, который проявляет стремление, способности и вовлеченность для перевода на позицию с более широким функционалом. Текущая позиция может всё ещё предоставлять возможности для роста или развития.<br><b>Рекомендуемое действие по сотруднику</b>: Развитие / Расширение функционала / Проекты'},
        '3_1': {name: '1. Формирующийся талант / Неэффективный сотрудник', desc: '<b>Описание</b>: Сотрудник, недавно переведенный на данную позицию, или непоследовательно развивающийся сотрудник, который может не продемонстрировать стремление, способности и вовлеченность, необходимые для продвижения на более высокую позицию или позицию с более широким функционалом. Сотрудник, не справляющийся с текущими функциональными задачами/ целями.<br><b>Рекомендуемое действие по сотруднику</b>: Наблюдение / Увольнение'},
        '3_2': {name: '3. Стабильный сотрудник', desc: '<b>Описание</b>: Эффективный сотрудник, который может не демонстрировать стремление, способности и вовлеченность, необходимые для продвижения на более высокую позицию или позицию с более широким функционалом.<br><b>Рекомендуемое действие по сотруднику</b>: Наблюдение'},
        '3_3': {name: '4. Ценный сотрудник', desc: '<b>Описание</b>: Сотрудник с высоким уровнем эффективности, который может не демонстрировать стремление, способности и вовлеченность, необходимые для продвижения, или который уже достиг предела своего карьерного потенциала.<br><b>Рекомендуемое действие по сотруднику</b>: Развитие'},
      }"
      @export-to-pdf="exportToPDF(1)"
    ></human-resources-matrix-block>

    <human-resources-matrix-block
      v-show="showMatrix2"
      id="human-resources-matrix-2"
      ref="human-resources-matrix-2"

      name="Матрица риска увольнения и влияния на бизнес"

      :row-evaluation-type="6"
      row-evaluation-type-comment="<b>Влияние на бизнес</b> - оценка влияния ухода сотрудника на бизнес"
      row-point-name="evaluate_impact_on_business_id"
      :col-evaluation-type="5"
      col-evaluation-type-comment="<b>Риск увольнения</b> - оценка вероятности того, что сотрудник покинет свою текущую должность в течение следующих 12 месяцев.(пример: демотивация, декретный отпуск, выход на пенсию либо карьерное продвижение на другую позицию)"
      col-point-name="evaluate_risk_dismissal_id"
      :rows-name-configs="{
        1: {evaluationId: 19},
        2: {evaluationId: 20},
        3: {evaluationId: 21},
      }"
      :cols-name-configs="{
        1: {evaluationId: 18},
        2: {evaluationId: 17},
        3: {evaluationId: 16},
      }"
      :table-cells-config="{
        '1_1': {name: '6. Низкий риск - Высокое влияние', desc:''},
        '1_2': {name: '8. Средний риск - Высокое влияние', desc: '<b>Рекомендуемое действие по сотруднику</b>: Анализ ситуации и, при необходимости, разработка плана действий по снижению риска и подготовке преемника'},
        '1_3': {name: '9. Высокий риск - Высокое влияние', desc: '<b>Рекомендуемое действие по сотруднику</b>: Анализ ситуации и, при необходимости, разработка плана действий по снижению риска и подготовка преемника'},
        '2_1': {name: '2. Низкий риск - Среднее влияние', desc: ''},
        '2_2': {name: '5. Средний риск - Среднее влияние', desc: ''},
        '2_3': {name: '7. Высокий риск - Среднее влияние', desc: '<b>Рекомендуемое действие по сотруднику</b>: Анализ ситуации и, при необходимости, разработка плана действий по снижению риска и подготовке преемника'},
        '3_1': {name: '1. Низкий риск - Низкое влияние', desc: ''},
        '3_2': {name: '3. Средний риск - Низкое влияние', desc: ''},
        '3_3': {name: '4. Высокий риск - Низкое влияние', desc: ''},
      }"
      @export-to-pdf="exportToPDF(2)"
    ></human-resources-matrix-block>

    <el-card
      v-if="$canAndRulesPass(user, 'resources_evaluation.matrix_comment_see')"
      v-show="showComments"
      style="margin-top: 20px"
    >
      <comments-block
        :disabled="!$canAndRulesPass(user, 'resources_evaluation.matrix_comment_create')"
        entity-type="resources_evaluation_matrix"
        :entity-id="parseInt($route.params.id)"
        :send-button-text="$companyConfiguration.i18n.t('card', 'comment_send_button_text', 'Отправить')"
      ></comments-block>
    </el-card>
  </div>
</template>
<script>

import {mapGetters} from "vuex";
import PageHeading from "@/components/PageHeading.vue";
import LibraryElements from "@/components/library/LibraryElements.vue";
import LibraryFolders from "@/components/library/LibraryFolders.vue";
import HumanResourcesMatrixTableUser
  from "@/componentsCompany/smz/humanResourcesMatrix/HumanResourcesMatrixTableUser.vue";
import HumanResourcesMatrixTableIntersectionName
  from "@/componentsCompany/smz/humanResourcesMatrix/HumanResourcesMatrixTableIntersectionName.vue";
import HumanResourcesMatrixBlock from "@/componentsCompany/smz/humanResourcesMatrix/HumanResourcesMatrixBlock.vue";
import HumanResourcesMatrixHeader from "@/componentsCompany/smz/humanResourcesMatrix/HumanResourcesMatrixHeader.vue";
import html2pdf from "html2pdf.js/src";
import CommentsBlock from "@/components/comments/CommentsBlock.vue";
export default {
  name: 'HumanResourcesMatrix',
  components: {
    CommentsBlock,
    HumanResourcesMatrixHeader,
    HumanResourcesMatrixBlock,
    HumanResourcesMatrixTableIntersectionName,
    HumanResourcesMatrixTableUser, LibraryFolders, LibraryElements, PageHeading},
  computed: {
    ...mapGetters(['user']),
  },


  data() {
    return {
      showMatrix1: true,
      showMatrix2: true,
      showComments: true,
    }
  },
  mounted() {

  },
  methods: {
    exportToPDF(matrixIndex){
      const matrixIndexToHide = matrixIndex === 1 ? 2 : 1;

      this['showMatrix'+matrixIndexToHide] = false;
      this.showComments = false;

      this.$refs["human-resources-matrix-"+matrixIndex].$data.exporting = true;

      const today = new Date();
      const yyyy = today.getFullYear() - 2000;
      let mm = today.getMonth() + 1;
      let dd = today.getDate();
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      const formattedToday = dd + mm + yyyy;

      html2pdf()
        .set({
          margin:       1,
          enableLinks: false,
          filename:     '9box' + matrixIndex + '_' + formattedToday + '.pdf',
          html2canvas:  { scale: 2 },
          jsPDF:        { unit: 'mm', format: 'a2', orientation: 'landscape' }
        })
        .from(document.getElementById('human-resources-view'))
        .save()
        .then(() => {
          this['showMatrix'+matrixIndexToHide] = true;
          this.showComments = true;
          this.$refs["human-resources-matrix-"+matrixIndex].$data.exporting = false;
        })
    }
  }
}
</script>

